import Slider from 'react-slick'
import apis from '../../../../../modules/apis'
import { axiosDelete } from '../../../../../modules/axiosHelper'
import { useCreateRolePlayStore } from '../../../../../store/useCreateRolePlayStore'
import { usePersonaStore } from '../../../../../store/usePersonaStore'
import PersonaCard from './PersonaCard'
const sliderSettings = {
  centerMode: true,
  centerPadding: '40px', // ← how much of next/prev to show
  slidesToShow: 1,
  infinite: false,
  speed: 500,
  arrows: false,
  dots: true,
  appendDots: (dots) => (
    <div style={{ marginTop: '20px' }}>
      <ul
        style={{
          margin: 0,
          padding: 0,
          display: 'flex',
          justifyContent: 'center',
          gap: '1px', // 👈 tighter spacing between dot-dot-dot
        }}
      >
        {dots}
      </ul>
    </div>
  ),
}

const Personas = ({ personas }) => {
  const { personaId, setPersonaId } = useCreateRolePlayStore()
  const { removePersona, jobCategories } = usePersonaStore()

  const deletePersona = async (id: number) => {
    const data = await axiosDelete(apis.aiTutor.persona.delete(id))
    console.log(data)

    removePersona(id)
  }

  return (
    <div style={{ width: '100%' }}>
      <Slider {...sliderSettings} className="pb-[16px]">
        {personas.map((persona, index) => {
          let showDeleteBtn = true
          if (persona.user_id === 1) {
            showDeleteBtn = false
          }

          console.log('persona =>', persona)

          return (
            <div
              key={index}
              style={{ padding: '0 8px' }} // ✅ This creates the spacing
              onClick={(e) => {
                setPersonaId(persona.id)
              }}
            >
              <>
                <PersonaCard
                  persona={persona}
                  personaId={personaId}
                  deletePersona={deletePersona}
                  showDeleteBtn={showDeleteBtn}
                />
              </>
            </div>
          )
        })}
      </Slider>
    </div>
  )
}

export default Personas
